import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import { CSSProperties } from "react";
import { Close } from "@mui/icons-material";

export type DefaultRadioGroupInputOption = {
  id: number,
  label: string,
  style?: CSSProperties,
} | {
  id: string,
  label: string,
  style?: CSSProperties,
};

/**
 * DefaultRadioGroupInput
 */

type Props = {
  name: string;
  label?: string;
  required?: boolean;
  options: DefaultRadioGroupInputOption[];
  showCleanButton?: boolean;
  readOnly?: boolean;
  helperText?: string;
  disabled?: boolean;
  value: string | number | null;
  onValueChange: (value: string | number | null) => void
};

export const DefaultRadioGroupInput = ({
  name,
  label,
  required,
  options,
  showCleanButton,
  readOnly,
  helperText,
  disabled,
  value,
  onValueChange
}: Props) => {
  return (
    <FormControl size="small" className="flex flex-row" required={required}>
      {label &&
        <FormLabel id="descontoSindical" error={helperText !== undefined && helperText !== null} required={required}>
          {label}
        </FormLabel>
      }

      <div className="flex flex-row items-center">
        <RadioGroup
          aria-labelledby={`input-radio-group-${name as string}`}
          name={name}
          value={value ?? null}
          aria-disabled={disabled}
          onChange={(e) => onValueChange(e.target.value)}
          row={true}>

          {options?.map(opt => (
            <FormControlLabel
              key={opt.id}
              className="text-black dark:text-white"
              value={opt.id}
              disabled={readOnly || disabled}
              control={<Radio size="small" />}
              label={<span style={opt.style}>{opt.label}</span>}
            />
          ))}

        </RadioGroup>
        {
          (showCleanButton && value !== null && value !== undefined && !disabled && !readOnly) &&
          <div className="ml-2">
            <span
              className="flex flex-row items-center cursor-pointer text-xs text-[#009C4E] font-bold"
              onClick={() => onValueChange(null)}>
              <Close /> Limpar
            </span>
          </div>
        }
      </div>

      <FormHelperText id={`input-radio-group-${name as string}`} error={helperText !== undefined && helperText !== null}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}